
                  export default function (Component) {
                      Component.__source = "src/components/noData.vue"
                  }
              